import React, { useState, useCallback } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import TableHeader from './TableHeader';
import { PreEx6Columns } from './PreEx6Columns';
import Row from './PreEx6Row';
import Refiner from 'Common/Components/Refiner/Refiner.container';
import { useFetchPreEx6MarkingTeams } from '../pre-ex6.service';
import styles from './table.module.css';
import { withFuncCompTracking } from '../../../../../../Telemetry/telemetry.service';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';
import Groupings from 'Common/Constants/Groupings';
import Section from 'Common/Layout/Section';
import { useSelector } from 'react-redux';
import { qualYearSelect, apptTypesSelect } from 'Redux/Selectors/Contracts.Globals.Selectors';

const TableBase = ({ handleActive }) => {	
	const { selected: qualYear } = useSelector(qualYearSelect);	
	const [page, setPage] = useState(0);
	const [sizePerPage, setSizePerPage] = useState(5);
    const persistedRefiner = useSelector(state => state.contract_globals.refiner);
    const [contracts, setContracts] = useState([]);
    const [refinerContracts, setRefinerContracts] = useState([]);
    const [selectedYear, setSelectedYear] = useState(qualYear.toString());
	const refinedTypes = useSelector(apptTypesSelect);
	const refinerFields = [
		{ name: 'type', label: "Appt Type", type: 'select', dataSource: refinedTypes.selected },
		{ name: 'markingMethod', label: 'Marking Method', type: 'text' },
		{ name: 'title', label: 'Title contains', type: 'text' },
		{ name: 'markingTeamCode', label: 'Marking Team Code', type: 'text' }
	];
	
    const { isLoading, total, handleRefinementSelectorsChange } = useFetchPreEx6MarkingTeams(page, sizePerPage, setContracts, selectedYear, persistedRefiner, refinerFields, setRefinerContracts);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = event => {
		setSizePerPage(parseInt(event.target.value, 10));
		setPage(0);
    };

    const updateYear = async year => {
        setSelectedYear(year);
    };

	const updateRowAppointmentId = (row, appointmentId) => {
		let contract = [...contracts];
		let index = contract.findIndex(x => x.markingTeamId === row.markingTeamId);
		let updatedRow = { ...row, appointmentId };
		contract[index] = updatedRow;
		setContracts(contract);
    };

    const [isFiltering, setIsFiltering] = useState(false);
    const [inPreview, setInPreview] = useState(false);
    const [refinerOpen, setRefinerOpen] = useState(true);
    const toggleRefiner = useCallback(() => setRefinerOpen(prev => !prev), []);

	return (
        <>
            <YearSelector numberOfPreviousYears={1} numberOfFutureYears={1} year={selectedYear} grouping={Groupings.Marker} updateYear={updateYear} />
            <Section>
                <h3 class="sr-only">Refine</h3>
				<Refiner
					disabled={isFiltering}
					fields={refinerFields}
					open={refinerOpen}
					readOnly={inPreview}
					data={refinerContracts}
					onRefinementSelectorsChange={handleRefinementSelectorsChange}
					onPanelToggleClick={toggleRefiner}
				/>
			</Section>
			<Card className={styles.root} variant="outlined">
				<CardHeader
				title={
					<Typography noWrap component="h3">
					   Contracts at Status Ready
					</Typography>
					}
				/>

				<CardContent className={styles.media} title="Contracts">
					{isLoading ? (
						<LinearProgress color="secondary" />
					) : (
						<TableContainer as={Paper}>
							<Table className={styles.table} size="small" aria-label="Contracts at Ready Status" role="table">
								<TableHeader columns={PreEx6Columns} />
								<TableBody>
									{contracts.map((row, i) => (
										<Row key={i} row={row} handleActive={handleActive} updateRowAppointmentId={updateRowAppointmentId} />
									))}
								</TableBody>
							</Table>
						</TableContainer>
					)}
					<TablePagination
						rowsPerPageOptions={[5, 10, 25]}
						component="div"
						count={total}
						rowsPerPage={sizePerPage}
						page={page}
						onPageChange={handleChangePage}
						onRowsPerPageChange={handleChangeRowsPerPage}
					/>
				</CardContent>
				<CardActions></CardActions>
			</Card>
		</>
	);
};

export default withFuncCompTracking('Pre Ex6 Table')(TableBase);